// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ts0w","top":"styles_top__2aflb"};